import instance from "@/utils/require.js"

// 系统设置--组织结构表格树查询
export function apiFactoryOrganizationTree(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization/tree_grid",
		method: "post",
		data
	})
}

// 系统设置--添加组织结构
export function apiFactoryOrgAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization/add",
		method: "post",
		data
	})
}

// 系统设置--修改组织结构
export function apiFactoryOrgUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization/update",
		method: "post",
		data
	})
}

// 系统设置--禁用组织结构
export function apiFactoryOrgDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization/disable",
		method: "post",
		data
	})
}

// 系统设置--启用组织结构
export function apiFactoryOrgEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization/enable",
		method: "post",
		data
	})
}

// 系统设置--上移组织结构
export function apiFactoryOrgMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization/move_up",
		method: "post",
		data
	})
}

// 系统设置--下移组织结构
export function apiFactoryOrgMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization/move_down",
		method: "post",
		data
	})
}

// 系统设置--组织结构树
export function apiFactoryOrganizationShow(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization/show",
		method: "post",
		data
	})
}

// 系统设置--组织结构类别--联级选择器下拉数据
export function apiFactoryOrgTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization_type/list",
		method: "post",
		data
	})
}

// 系统设置--组织结构类别表格
export function apiFactoryOrgTypeGrid(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization_type/tree_grid",
		method: "post",
		data
	})
}

// 系统设置--组织结构类别树
export function apiFactoryOrgTypeShow(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization_type/show",
		method: "post",
		data
	})
}

// 系统设置--组织结构类别添加
export function apiFactoryOrgTypeAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization_type/add",
		method: "post",
		data
	})
}

// 系统设置--组织结构类别修改
export function apiFactoryOrgTypeUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization_type/update",
		method: "post",
		data
	})
}

// 系统设置--组织结构类别禁用
export function apiFactoryOrgTypeDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization_type/disable",
		method: "post",
		data
	})
}

// 系统设置--组织结构类别启用
export function apiFactoryOrgTypeEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization_type/enable",
		method: "post",
		data
	})
}

// 系统设置--组织结构类别上移
export function apiFactoryOrgTypeMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization_type/move_up",
		method: "post",
		data
	})
}

// 系统设置--组织结构类别下移
export function apiFactoryOrgTypeMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization_type/move_down",
		method: "post",
		data
	})
}

// 工序管理--工序生产线
export function apiFactoryProductionLine(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization_type/production_line",
		method: "post",
		data
	})
}

// 工序管理--工序表格数据
export function apiFactoryWorkStationSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/work_station/search",
		method: "post",
		data
	})
}

// 工序管理--添加工序
export function apiFactoryWorkStationAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/work_station/add",
		method: "post",
		data
	})
}

// 工序管理--修改工序
export function apiFactoryWorkStationUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/work_station/update",
		method: "post",
		data
	})
}

// 工序管理--工序表格上移
export function apiFactoryWorkStationMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/work_station/move_up",
		method: "post",
		data
	})
}

// 工序管理--工序表格下移
export function apiFactoryWorkStationMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/work_station/move_down",
		method: "post",
		data
	})
}

// 工序管理--工序表格启用
export function apiFactoryWorkStationEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/work_station/enable",
		method: "post",
		data
	})
}

// 工序管理--工序表格禁用
export function apiFactoryWorkStationMoveDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/work_station/disable",
		method: "post",
		data
	})
}

// 工序管理--标签类型下拉
export function apiLabelType(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/label_type",
		method: "post",
		data
	})
}

// 开发者管理--表格数据
export function apiOpenKeySearch(data = {}) {
	return instance({
		url: "/aim/api/v3/open_key/search",
		method: "post",
		data
	})
}

// 开发者管理--添加开发者
export function apiOpenKeyAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/open_key/add",
		method: "post",
		data
	})
}

// 开发者管理--修改开发者
export function apiOpenKeyUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/open_key/update",
		method: "post",
		data
	})
}

// 开发者管理--禁用开发者
export function apiOpenKeyDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/open_key/disable",
		method: "post",
		data
	})
}

// 开发者管理--启用开发者
export function apiOpenKeyEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/open_key/enable",
		method: "post",
		data
	})
}

// 开发者管理--上移开发者
export function apiOpenKeyMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/open_key/move_up",
		method: "post",
		data
	})
}

// 开发者管理--下移开发者
export function apiOpenKeyMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/open_key/move_down",
		method: "post",
		data
	})
}

// 开发者管理--获取key
export function apiOpenKeyGeneratorKey(data = {}) {
	return instance({
		url: "/aim/api/v3/open_key/generator_key",
		method: "post",
		data
	})
}



// QC设置--QC表格数据
export function apiQcResultCodeSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_result_code/search",
		method: "post",
		data
	})
}

// QC设置--修改数据
export function apiQcResultCodeUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_result_code/update",
		method: "post",
		data
	})
}

// QC设置--新增数据
export function apiQcResultCodeAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_result_code/add",
		method: "post",
		data
	})
}
// QC设置--是否可返回组装工序
export function apiQcUpdateIsBack(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_result_code/updateIsBack",
		method: "post",
		data
	})
}
// QC设置--删除数据
export function apiQcResultCodeDel(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_result_code/delete",
		method: "post",
		data
	})
}
// 系统设置--获取QCCode 树数据
export function apiQcCodeTree(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_result_code/qcCodeTree",
		method: "post",
		data
	})
}




// 维修设置--维修表格数据
export function apiRepairCodeSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/repair_code/search",
		method: "post",
		data
	})
}

//维修设置--修改数据
export function apiRepairCodeUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/repair_code/update",
		method: "post",
		data
	})
}

// 维修设置--新增数据
export function apiRepairCodeAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/repair_code/add",
		method: "post",
		data
	})
}

// 维修设置--删除数据
export function apiRepairCodeDel(data = {}) {
	return instance({
		url: "/aim/api/v3/repair_code/delete",
		method: "post",
		data
	})
}

// 获取维修类别
export function apiGetTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/repair_code/getTypeList",
		method: "post",
		data
	})
}

// 维修等级下拉
export function apiRepairLevel(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/repair_level",
		method: "post",
		data
	})
}